"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const checkEndOfOver = (props) => {
    if (props.noBall && props.noBall.rebowled === undefined)
        props.noBall.rebowled = true;
    if (props.wide && props.wide.rebowled === undefined)
        props.wide.rebowled = true;
    if ((props.ballDisplayNum >= props.ballsPerOver &&
        (((!props.noBall || (props.noBall && !props.noBall.isNoBall)) &&
            (!props.wide || (props.wide && props.wide.isWide))) ||
            (props.wide &&
                props.wide.isWide &&
                !props.wide.rebowled &&
                (!props.wide.rebowledLastOver || (props.wide.rebowledLastOver && !props.isLastOverOfInnings))) ||
            (props.noBall &&
                props.noBall.isNoBall &&
                !props.noBall.rebowled &&
                (!props.noBall.rebowledLastOver || (props.noBall.rebowledLastOver && !props.isLastOverOfInnings))))) ||
        (props.pairs && props.pairs.maxBalls && props.pairs.ballNum >= props.pairs.maxBalls)) {
        return true;
    }
    else {
        return false;
    }
};
exports.default = checkEndOfOver;
//# sourceMappingURL=checkEndOfOver.js.map